import request from '@/utils/request'

export function getStaffUserMsgCountList(data) {
  return request({
    url: 'api/getStaffUserMsgCountList',
    method: 'post',
    params: data
  })
}

export function getDealerUserMsgCountList(data) {
  return request({
    url: 'api/getDealerUserMsgCountList',
    method: 'post',
    params: data
  })
}

export function getClientGroupList(data) {
  return request({
    url: 'api/getClientGroupList',
    method: 'post',
    params: data
  })
}

export function getClientLabel(data) {
  return request({
    url: 'api/getClientLabel',
    method: 'post',
    params: data
  })
}

export function editClientLabel(data) {
  return request({
    url: 'api/editClientLabel',
    method: 'post',
    params: data
  })
}

export function addClient(data) {
  return request({
    url: 'api/addClient',
    method: 'post',
    params: data
  })
}

export function editClientGroup(data) {
  return request({
    url: 'api/editClientGroup',
    method: 'post',
    params: data
  })
}

export function getClientList(data) {
  return request({
    url: 'api/getClientList',
    method: 'post',
    params: data
  })
}

export function delClient(data) {
  return request({
    url: 'api/delClient',
    method: 'post',
    params: data
  })
}

export function forwardClient(data) {
  return request({
    url: 'api/forwardClient',
    method: 'post',
    params: data
  })
}

export function getWays() {
  return request({
    url: 'api/getWays',
    method: 'post'
  })
}

export function getClentFollowList(data) {
  return request({
    url: 'api/getClentFollowList',
    method: 'post',
    params: data
  })
}

export function getAllClientList(data) {
  return request({
    url: 'api/getAllClientList',
    method: 'post',
    params: data
  })
}

export function getUserFollowRecord(data) {
  return request({
    url: 'api/getUserFollowRecord',
    method: 'post',
    params: data
  })
}

export function getClientDetail(data) {
  return request({
    url: 'api/getClientDetail',
    method: 'post',
    params: data
  })
}

export function getClientDetail2(data) {
  return request({
    url: 'api/getClientDetail2',
    method: 'post',
    params: data
  })
}

export function editFollowRecord(data) {
  return request({
    url: 'api/editFollowRecord',
    method: 'post',
    params: data
  })
}

export function changeClientIntent(data) {
  return request({
    url: 'api/changeClientIntent',
    method: 'post',
    params: data
  })
}

export function getClientWaitPayNum(data) {
  return request({
    url: 'api/getClientWaitPayNum',
    method: 'post',
    params: data
  })
}

export function getWayAndLabels(data) {
  return request({
    url: 'api/getWayAndLabels',
    method: 'post',
    params: data
  })
}

export function intoHighSeas(data) {
  return request({
    url: 'api/intoHighSeas',
    method: 'post',
    params: data
  })
}

export function getPublicClient(data) {
  return request({
    url: 'api/getPublicClient',
    method: 'post',
    params: data
  })
}

export function followPublicClient(data) {
  return request({
    url: 'api/followPublicClient',
    method: 'post',
    params: data
  })
}

export function putPublicClientToSeas(data) {
  return request({
    url: 'api/putPublicClientToSeas',
    method: 'post',
    params: data
  })
}

export function getContractList(data) {
  return request({
    url: 'api/getContractList',
    method: 'post',
    params: data
  })
}

export function addOrEditContract(data) {
  return request({
    url: 'api/addOrEditContract',
    method: 'post',
    params: data
  })
}

export function delContract(data) {
  return request({
    url: 'api/delContract',
    method: 'post',
    params: data
  })
}

export function getBrandList() {
  return request({
    url: 'api/getBrandList',
    method: 'post'
  })
}

export function signContract(data) {
  return request({
    url: 'api/signContract',
    method: 'post',
    params: data
  })
}

export function getSignedList(data) {
  return request({
    url: 'api/getSignedList',
    method: 'post',
    params: data
  })
}

export function getSignedContract(data) {
  return request({
    url: 'api/getSignedContract',
    method: 'post',
    params: data
  })
}

export function getWaitPayList(data) {
  return request({
    url: 'api/getWaitPayList',
    method: 'post',
    params: data
  })
}

export function addOrUpdateWaitPay(data) {
  return request({
    url: 'api/addOrUpdateWaitPay',
    method: 'post',
    params: data
  })
}

export function addOrEditWaitPay(data) {
  return request({
    url: 'api/addOrEditWaitPay',
    method: 'post',
    params: data
  })
}

export function getMoneyCheckList(data) {
  return request({
    url: 'api/getMoneyCheckList',
    method: 'post',
    params: data
  })
}

export function getMoneyCheckListByDir(data) {
  return request({
    url: 'api/getMoneyCheckListByDir',
    method: 'post',
    params: data
  })
}

export function getClientInmonListByDir(data) {
  return request({
    url: 'api/getClientInmonListByDir',
    method: 'post',
    params: data
  })
}

export function getClientRefundListByDir(data) {
  return request({
    url: 'api/getClientRefundListByDir',
    method: 'post',
    params: data
  })
}

export function getClientRefundListByCw(data) {
  return request({
    url: 'api/getClientRefundListByCw',
    method: 'post',
    params: data
  })
}

export function getClientInmonListByCw(data) {
  return request({
    url: 'api/getClientInmonListByCw',
    method: 'post',
    params: data
  })
}

export function getMerchantsMoneyDetail(data) {
  return request({
    url: 'api/getMerchantsMoneyDetail',
    method: 'post',
    params: data
  })
}

export function getClientInmonDetail(data) {
  return request({
    url: 'api/getClientInmonDetail',
    method: 'post',
    params: data
  })
}

export function getClientRefundDetail(data) {
  return request({
    url: 'api/getClientRefundDetail',
    method: 'post',
    params: data
  })
}

export function checkMerchantsMoney(data) {
  return request({
    url: 'api/checkMerchantsMoney',
    method: 'post',
    params: data
  })
}

export function checkMerchantsMoneyByDir(data) {
  return request({
    url: 'api/checkMerchantsMoneyByDir',
    method: 'post',
    params: data
  })
}

export function checkClientInmonByDir(data) {
  return request({
    url: 'api/checkClientInmonByDir',
    method: 'post',
    params: data
  })
}

export function checkClientRefundByDir(data) {
  return request({
    url: 'api/checkClientRefundByDir',
    method: 'post',
    params: data
  })
}

export function checkClientRefundByCw(data) {
  return request({
    url: 'api/checkClientRefundByCw',
    method: 'post',
    params: data
  })
}

export function checkClientInmonByCw(data) {
  return request({
    url: 'api/checkClientInmonByCw',
    method: 'post',
    params: data
  })
}

export function getPersonWaitList(data) {
  return request({
    url: 'api/getPersonWaitList',
    method: 'post',
    params: data
  })
}

export function personWaitDetail(data) {
  return request({
    url: 'api/personWaitDetail',
    method: 'post',
    params: data
  })
}

export function addOrEditPersonAssign(data) {
  return request({
    url: 'api/addOrEditPersonAssign',
    method: 'post',
    params: data
  })
}

export function getDealerList(data) {
  return request({
    url: 'api/getDealerList',
    method: 'post',
    params: data
  })
}

export function updateDealerVip(data) {
  return request({
    url: 'api/updateDealerVip',
    method: 'post',
    params: data
  })
}

export function getDealerDetail(data) {
  return request({
    url: 'api/getDealerDetail',
    method: 'post',
    params: data
  })
}

export function updateDealerInfo(data) {
  return request({
    url: 'api/updateDealerInfo',
    method: 'post',
    params: data
  })
}

export function updateDealerInfoFile(data) {
  return request({
    url: 'api/updateDealerInfoFile',
    method: 'post',
    params: data
  })
}

export function getDealerUserList(data) {
  return request({
    url: 'api/getDealerUserList',
    method: 'post',
    params: data
  })
}

export function updateDealerUserInfo(data) {
  return request({
    url: 'api/updateDealerUserInfo',
    method: 'post',
    params: data
  })
}

export function setMainOrDelDealerUser(data) {
  return request({
    url: 'api/setMainOrDelDealerUser',
    method: 'post',
    params: data
  })
}

export function getDealerTelList(data) {
  return request({
    url: 'api/getDealerTelList',
    method: 'post',
    params: data
  })
}

export function editDealerTel(data) {
  return request({
    url: 'api/editDealerTel',
    method: 'post',
    params: data
  })
}

export function getProgramSchedule(data) {
  return request({
    url: 'api/getProgramSchedule',
    method: 'post',
    params: data
  })
}

export function getLifeDeviceTypeList(data) {
  return request({
    url: 'api/getLifeDeviceTypeList',
    method: 'post',
    params: data
  })
}

export function editLifeDeviceType(data) {
  return request({
    url: 'api/editLifeDeviceType',
    method: 'post',
    params: data
  })
}

export function delLifeDeviceType(data) {
  return request({
    url: 'api/delLifeDeviceType',
    method: 'post',
    params: data
  })
}

export function getPlanStageList() {
  return request({
    url: 'api/getPlanStageList',
    method: 'post'
  })
}

export function getProgramDetail(data) {
  return request({
    url: 'api/getProgramDetail',
    method: 'post',
    params: data
  })
}

export function addOrEditProgramSchedule(data) {
  return request({
    url: 'api/addOrEditProgramSchedule',
    method: 'post',
    params: data
  })
}

export function getExProgramList(data) {
  return request({
    url: 'api/getExProgramList',
    method: 'post',
    params: data
  })
}

export function getExAssignDetail(data) {
  return request({
    url: 'api/getExAssignDetail',
    method: 'post',
    params: data
  })
}

export function addOrEditExAssign(data) {
  return request({
    url: 'api/addOrEditExAssign',
    method: 'post',
    params: data
  })
}

export function getProgramAssignList(data) {
  return request({
    url: 'api/getProgramAssignList',
    method: 'post',
    params: data
  })
}

export function getAssignFollowList(data) {
  return request({
    url: 'api/getAssignFollowList',
    method: 'post',
    params: data
  })
}

export function addOrEditAssignFollow(data) {
  return request({
    url: 'api/addOrEditAssignFollow',
    method: 'post',
    params: data
  })
}

/**
 * 物料列表（带搜索）
 * @param data
 */
export function getMaterialManagerList(data) {
  return request({
    url: 'api/getMaterialManagerList',
    method: 'post',
    params: data
  })
}

/**
 * 删除物料
 * @param data
 */
export function delMaterial(data) {
  return request({
    url: 'api/delMaterial',
    method: 'post',
    params: data
  })
}

/**
 * 获取物料信息
 * @param data
 */
export function getMaterialInfo(data) {
  return request({
    url: 'api/getMaterialInfo',
    method: 'post',
    params: data
  })
}

/**
 * 添加编辑物料操作
 * @param data
 */
export function addOrEditMaterial(data) {
  return request({
    url: 'api/addOrEditMaterial',
    method: 'post',
    params: data
  })
}

/**
 * 物料入库，出库
 * @param data
 */
export function materialStorage(data) {
  return request({
    url: 'api/materialStorage',
    method: 'post',
    params: data
  })
}

/**
 * 出入库记录
 * @param data
 */
export function getStorageRecord(data) {
  return request({
    url: 'api/getStorageRecord',
    method: 'post',
    params: data
  })
}

/**
 * 物料预警
 * @param data
 */
export function getMaterialWarning(data) {
  return request({
    url: 'api/getMaterialWarning',
    method: 'post',
    params: data
  })
}

/**
 * 物料统计
 * @param data
 */
export function getMaterialProfit(data) {
  return request({
    url: 'api/getMaterialProfit',
    method: 'post',
    params: data
  })
}

/**
 * 物料统计详情
 * @param data
 */
export function getMaterialProfitDetail(data) {
  return request({
    url: 'api/getMaterialProfitDetail',
    method: 'post',
    params: data
  })
}

/**
 * 物料统计excel导出
 * @param data
 */
export function exportMaterialProfitExcel(data) {
  return request({
    url: 'api/exportMaterialProfitExcel',
    method: 'post',
    params: data
  })
}

/**
 * 物料按月利润统计
 * @param data
 */
export function getMaterialProfitMonth(data) {
  return request({
    url: 'api/getMaterialProfitMonth',
    method: 'post',
    params: data
  })
}

/**
 * 查询活动期间部件卖出金额
 * @param data
 * @returns {*}
 */
export function getMaterialActivityInfo(data) {
  return request({
    url: 'api/getMaterialActivityInfo',
    method: 'post',
    params: data
  })
}

/**
 * 查询活动期间部件卖出金额
 * @param data
 * @returns {*}
 */
export function exportMaterialActivityExcel(data) {
  return request({
    url: 'api/exportMaterialActivityExcel',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请列表
 * @param data
 */
export function getMaterialApplyList(data) {
  return request({
    url: 'api/getMaterialApplyList',
    method: 'post',
    params: data
  })
}

/**
 * （经销商端）物料申请列表
 * @param data
 */
export function getMaterialApplyListOfDealer(data) {
  return request({
    url: 'api/getMaterialApplyListOfDealer',
    method: 'post',
    params: data
  })
}
/**
 * 物料申领列表（内部）
 * @param data
 */
export function getMaterialClaimList(data) {
  return request({
    url: 'api/getMaterialClaimList',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请详情
 * @param data
 */
export function getMaterialApplyDetail(data) {
  return request({
    url: 'api/getMaterialApplyDetail',
    method: 'post',
    params: data
  })
}
/**
 * 物料申请添加/编辑
 * @param data
 */
export function addOrEditMaterialApply(data) {
  return request({
    url: 'api/addOrEditMaterialApply',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请添加/编辑
 * @param data
 */
export function deleteMaterialApply(data) {
  return request({
    url: 'api/deleteMaterialApply',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请单收款详细
 * @param data
 */
export function materialsCollectRecord(data) {
  return request({
    url: 'api/materialsCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请单添加收款
 * @param data
 */
export function editMaterialCollectRecord(data) {
  return request({
    url: 'api/editMaterialCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 删除物料申请单收款
 * @param data
 */
export function delMaterialCollectRecord(data) {
  return request({
    url: 'api/delMaterialCollectRecord',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请打印
 * @param data
 */
export function printMaterialsApply(data) {
  return request({
    url: 'api/printMaterialsApply',
    method: 'post',
    params: data
  })
}

/**
 * 根据物料申请单收款记录ID查询详情
 * @param data
 */
export function getCollectRecordMaterialsByCrmid(data) {
  return request({
    url: 'api/getCollectRecordMaterialsByCrmid',
    method: 'post',
    params: data
  })
}

/**
 * 物料申请处理
 * @param data
 */
export function treatMaterialApply(data) {
  return request({
    url: 'api/treatMaterialApply',
    method: 'post',
    params: data
  })
}
/**
 * 删除资讯
 * @param data
 */
export function deleteNews(data) {
  return request({
    url: 'api/deleteNews',
    method: 'post',
    params: data
  })
}

/**
 * 更新资讯
 * @param data
 */
export function updateNews(data) {
  return request({
    url: 'api/updateNews',
    method: 'post',
    params: data
  })
}

/**
 * 添加资讯
 * @param data
 */
export function addNews(data) {
  return request({
    url: 'api/addNews',
    method: 'post',
    params: data
  })
}

/**
 * 日签列表
 * @param data
 */
export function getDaySign(data) {
  return request({
    url: 'api/getDaysign',
    method: 'post',
    params: data
  })
}

/**
 * 日签详情
 * @param data
 */
export function getDaySignDetail(data) {
  return request({
    url: 'api/getDaysignDetail',
    method: 'post',
    params: data
  })
}
/**
 * 添加日签
 * @param data
 */
export function addDaySign(data) {
  return request({
    url: 'api/editDaySign',
    method: 'post',
    params: data
  })
}
/**
 * 删除日签
 * @param data
 */
export function deleteDaySign(data) {
  return request({
    url: 'api/deleteDaySign',
    method: 'post',
    params: data
  })
}
/**
 * 获取日报
 * @param data
 */
export function getDailyList(data) {
  return request({
    url: 'api/getDailyList',
    method: 'post',
    params: data
  })
}

/**
 * 删除日报
 * @param data
 */
export function deleteDaily(data) {
  return request({
    url: 'api/deleteDaily',
    method: 'post',
    params: data
  })
}

/**
 * 修改添加日报
 * @param data
 */
export function addOrEditDaily(data) {
  return request({
    url: 'api/addOrEditDaily',
    method: 'post',
    params: data
  })
}

/**
 * 日报详情
 * @param data
 */
export function getDailyDetail(data) {
  return request({
    url: 'api/getDailyDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户工作内容
 * @returns
 */
export function getUserWork(data) {
  return request({
    url: 'api/getUserWork',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户列表
 * @returns
 */
export function getUserList(data) {
  return request({
    url: 'api/getAllUserList',
    method: 'post',
    params: data
  })
}

/**
 * 用户详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getUserDetail(data) {
  return request({
    url: 'api/getUserDetail',
    method: 'post',
    params: data
  })
}

/**
 * 用户审核
 * @param data
 */
export function checkRegisterUser(data) {
  return request({
    url: 'api/checkRegisterUser',
    method: 'post',
    params: data
  })
}

/**
 * 修改添加公告
 * @param data
 */
export function addOrEditNotice(data) {
  return request({
    url: 'api/addOrEditNotice',
    method: 'post',
    params: data
  })
}

/**
 * 删除公告
 * @param data
 */
export function deleteNotice(data) {
  return request({
    url: 'api/deleteNotice',
    method: 'post',
    params: data
  })
}

/**
 * 修改用户状态
 * @param data
 */
export function editUserMark(data) {
  return request({
    url: 'api/editUserMark',
    method: 'post',
    params: data
  })
}

/**
 * 修改用户职位
 * @param data
 */
export function editUserPosition(data) {
  return request({
    url: 'api/editUserPosition',
    method: 'post',
    params: data
  })
}

/**
 * 修改用户部门
 * @param data
 */
export function editUserDept(data) {
  return request({
    url: 'api/editUserDept',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户自己的智享库
 * @param data
 */
export function getUserShareData(data) {
  return request({
    url: 'api/getShareData',
    method: 'post',
    params: data
  })
}

/**
 * 删除分享
 * @param data
 */
export function deleteShare(data) {
  return request({
    url: 'api/deleteShare',
    method: 'post',
    params: data
  })
}
/**
 * 修改分享
 * @param data
 */
export function editShareData(data) {
  return request({
    url: 'api/editShareData',
    method: 'post',
    params: data
  })
}
/**
 * 修改订单信息
 * @param data
 */
export function editOrderInfo(data) {
  return request({
    url: 'api/editOrderInfo',
    method: 'post',
    params: data
  })
}

/**
 * 经销商账户列表
 * @param data
 */
export function getDealerAccountList(data) {
  return request({
    url: 'api/getDealerAccountList',
    method: 'post',
    params: data
  })
}

/**
 * 导出经销商账户列表
 * @param data
 */
export function excelDealerAccountList(data) {
  return request({
    url: 'api/excelDealerAccountList',
    method: 'post',
    params: data
  })
}

/**
 * 导出经销商售后赔款列表
 * @param data
 */
export function excelAfterAccountList(data) {
  return request({
    url: 'api/excelAfterAccountList',
    method: 'post',
    params: data
  })
}

/**
 * 导出经销商返点列表
 * @param data
 */
export function excelRebaceAccountList(data) {
  return request({
    url: 'api/excelRebaceAccountList',
    method: 'post',
    params: data
  })
}

/**
 * 删除订单动态
 * @param data
 */
export function deleteOrderDynamic(data) {
  return request({
    url: 'api/deleteOrderDynamic',
    method: 'post',
    params: data
  })
}

/**
 * 组织列表
 */
export function getGroup() {
  return request({
    url: 'api/getGroup',
    method: 'post'
  })
}

/**
 * 导出物料列表
 * @param data
 */
export function exportMaterialsExcel(data) {
  return request({
    url: 'api/exportMaterialsExcel',
    method: 'post',
    params: data
  })
}

/**
 * 根据文件ID获取文件信息（CAD预览）
 * @param data
 */
export function getFileInfoByCAD(data) {
  return request({
    url: 'api/getFileInfoByCAD',
    method: 'post',
    params: data
  })
}

export function getMaterialDataList(data) {
  return request({
    url: 'api/getMaterialDataList',
    method: 'post',
    params: data
  })
}

/**
 * 课程管理获取课程信息
 * @param data
 * @returns {AxiosPromise}
 */
export function getKcglCourseList(data) {
  return request({
    url: 'api/getKcglCourseList',
    method: 'post',
    params: data
  })
}

/**
 * 课程管理获取课程评论
 * @param data
 * @returns {AxiosPromise}
 */
export function getCourseCommet(data) {
  return request({
    url: 'api/getCourseCommet',
    method: 'post',
    params: data
  })
}

/**
 * 删除课程评论回复
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteReply(data) {
  return request({
    url: 'api/deleteReply',
    method: 'post',
    params: data
  })
}
/**
 * 删除课程评论
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteComment(data) {
  return request({
    url: 'api/deleteComment',
    method: 'post',
    params: data
  })
}
/**
 * 查询此课程用户的学习记录
 * @param data
 * @returns {AxiosPromise}
 */
export function selectStudyRecord(data) {
  return request({
    url: 'api/selectStudyRecord',
    method: 'post',
    params: data
  })
}

/**
 * 查询课程类别
 * @param data
 * @returns {AxiosPromise}
 */
export function getCourseClass() {
  return request({
    url: 'api/getCourseClass',
    method: 'post'
  })
}
/**
 * 获取学习Banner
 * @param data
 * @returns {AxiosPromise}
 */
export function getBannerList(data) {
  return request({
    url: 'api/getBannerList',
    method: 'post',
    params: data
  })
}

/**
 * 添加或修改Banner图
 * @param data
 * @returns {AxiosPromise}
 */
export function editBanner(data) {
  return request({
    url: 'api/editBanner',
    method: 'post',
    params: data
  })
}
/**
 * 删除Banner图
 * @param data
 * @returns {AxiosPromise}
 */
export function delBanner(data) {
  return request({
    url: 'api/delBanner',
    method: 'post',
    params: data
  })
}
/**
 * 根据id获取课程
 * @param data
 * @returns {AxiosPromise}
 */
export function getCourseByCid(data) {
  return request({
    url: 'api/getCourseByCid',
    method: 'post',
    params: data
  })
}
/**
 * 查询我指派的考试任务
 * @param data
 * @returns {AxiosPromise}
 */
export function getMyExamTask(data) {
  return request({
    url: 'api/getMyExamTask',
    method: 'post',
    params: data
  })
}
/**
 * 查询和搜索试卷
 * @param data
 * @returns {AxiosPromise}
 */
export function getPaperList(data) {
  return request({
    url: 'api/getPaperList',
    method: 'post',
    params: data
  })
}
/**
 * 根据id查找试卷
 * @param data
 * @returns {AxiosPromise}
 */
export function getPaperById(data) {
  return request({
    url: 'api/getPaperById',
    method: 'post',
    params: data
  })
}

/**
 * 添加或者修改考试任务指派
 * @param data
 * @returns {AxiosPromise}
 */
export function editExamTask(data) {
  return request({
    url: 'api/editExamTask',
    method: 'post',
    params: data
  })
}
/**
 * 获取部门员工Tree
 * @param data
 * @returns {AxiosPromise}
 */
export function getDeptEmployeeTree(data) {
  return request({
    url: 'api/getDeptEmployeeTree',
    method: 'post',
    params: data
  })
}
/**
 * 获取部门Tree
 * @param data
 * @returns {AxiosPromise}
 */
export function getDeptTree(data) {
  return request({
    url: 'api/getDeptTree',
    method: 'post',
    params: data
  })
}

/**
 * 获取考试任务指派类型中的数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getAssignData(data) {
  return request({
    url: 'api/getAssignData',
    method: 'post',
    params: data
  })
}
/**
 * 删除考试指派任务
 * @param data
 * @returns {AxiosPromise}
 */
export function delExamTask(data) {
  return request({
    url: 'api/delExamTask',
    method: 'post',
    params: data
  })
}
/**
 * 经销商添加考试指派任务
 * @param data
 * @returns {AxiosPromise}
 */
export function dealerEditExamTask(data) {
  return request({
    url: 'api/dealerEditExamTask',
    method: 'post',
    params: data
  })
}
/**
 * 获取属于此经销商的所有用户
 * @param data
 * @returns {AxiosPromise}
 */
export function selectDealerList(data) {
  return request({
    url: 'api/selectDealerList',
    method: 'post',
    params: data
  })
}
/**
 * 获取属于此经销商的所有用户
 * @param data
 * @returns {AxiosPromise}
 */
export function getExamTaskDealerId(data) {
  return request({
    url: 'api/getExamTaskDealerId',
    method: 'post',
    params: data
  })
}
/**
 * 查询获取登录员工指派的调查问卷指派任务
 * @param data
 * @returns {AxiosPromise}
 */
export function getMyResearchTask(data) {
  return request({
    url: 'api/getMyResearchTask',
    method: 'post',
    params: data
  })
}
/**
 * 查询或搜索调查问卷
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchList(data) {
  return request({
    url: 'api/getResearchList',
    method: 'post',
    params: data
  })
}
/**
 * 添加或者修改调查问卷任务指派
 * @param data
 * @returns {AxiosPromise}
 */
export function editResearchTask(data) {
  return request({
    url: 'api/editResearchTask',
    method: 'post',
    params: data
  })
}
/**
 * 根据id查询调查问卷
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchById(data) {
  return request({
    url: 'api/getResearchById',
    method: 'post',
    params: data
  })
}
/**
 * 根据id查询调查问卷
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchAssignData(data) {
  return request({
    url: 'api/getResearchAssignData',
    method: 'post',
    params: data
  })
}

/**
 * 删除问卷调查指派任务
 * @param data
 * @returns {AxiosPromise}
 */
export function delResearchTask(data) {
  return request({
    url: 'api/delResearchTask',
    method: 'post',
    params: data
  })
}
/**
 * 经销商添加或修改问卷调查任务
 * @param data
 * @returns {AxiosPromise}
 */
export function dealerEditResearchTask(data) {
  return request({
    url: 'api/dealerEditResearchTask',
    method: 'post',
    params: data
  })
}
/**
 * 经销商获取问卷调查任务指派数据
 * @param data
 * @returns {AxiosPromise}
 */
export function getDealerResearchTaskAssignData(data) {
  return request({
    url: 'api/getDealerResearchTaskAssignData',
    method: 'post',
    params: data
  })
}
/**
 * 考试任务指派详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getExamTaskDetailZJY(data) {
  return request({
    url: 'api/getExamTaskDetailZJY',
    method: 'post',
    params: data
  })
}
/**
 * 查询考试记录详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getExamRecordZJY(data) {
  return request({
    url: 'api/getExamRecordZJY',
    method: 'post',
    params: data
  })
}
/**
 * 获取用户考试试题记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getOptionRecordZJY(data) {
  return request({
    url: 'api/getOptionRecordZJY',
    method: 'post',
    params: data
  })
}
/**
 * 考试指派详情导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportViewZJY(data) {
  return request({
    url: 'api/exportViewZJY',
    method: 'post',
    params: data
  })
}

/**
 * 问卷调查指派详情
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchTaskDetailZJY(data) {
  return request({
    url: 'api/getResearchTaskDetailZJY',
    method: 'post',
    params: data
  })
}
/**
 * 问卷调查指派详情导出
 * @param data
 * @returns {AxiosPromise}
 */
export function exportViewExcelZJY(data) {
  return request({
    url: 'api/exportViewExcelZJY',
    method: 'post',
    params: data
  })
}
/**
 * 问卷调查用户提交记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchRecordZJY(data) {
  return request({
    url: 'api/getResearchRecordZJY',
    method: 'post',
    params: data
  })
}
/**
 * 问卷调查提交选项记录(多选单选)
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchSubTwoZJY(data) {
  return request({
    url: 'api/getResearchSubTwoZJY',
    method: 'post',
    params: data
  })
}
/**
 * 问卷调查提交选项记录(输入框/评分)
 * @param data
 * @returns {AxiosPromise}
 */
export function getResearchSubOneZJY(data) {
  return request({
    url: 'api/getResearchSubOneZJY',
    method: 'post',
    params: data
  })
}
/**
 * 根据id获取试卷、试题、选项、试题图片
 * @param data
 * @returns {AxiosPromise}
 */
export function getProblem2ListById(data) {
  return request({
    url: 'api/getProblem2ListById',
    method: 'post',
    params: data
  })
}
/**
 * 根据id获取问卷、题目、选项
 * @param data
 * @returns {AxiosPromise}
 */
export function getTopicList2ById(data) {
  return request({
    url: 'api/getTopicList2ById',
    method: 'post',
    params: data
  })
}
/**
 * 获取采购管控
 * @param data
 * @returns {AxiosPromise}
 */
export function getPurchaseControlList(data) {
  return request({
    url: 'api/getPurchaseControlList',
    method: 'post',
    params: data
  })
}
/**
 * 导出采购管控明细表
 * @param data
 * @returns {AxiosPromise}
 */
export function exportPurchaseControlOfferExcel(data) {
  return request({
    url: 'api/exportPurchaseControlOfferExcel',
    method: 'post',
    params: data
  })
}
/**
 * 删除采购管控
 * @param data
 * @returns {AxiosPromise}
 */
export function deletePurchaseControl(data) {
  return request({
    url: 'api/deletePurchaseControl',
    method: 'post',
    params: data
  })
}
/**
 * 修改或添加采购管控
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditPurchaseControl(data) {
  return request({
    url: 'api/addOrEditPurchaseControl',
    method: 'post',
    params: data
  })
}
/**
 * 获取客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintRecordList(data) {
  return request({
    url: 'api/getComplaintRecordList',
    method: 'post',
    params: data
  })
}
/**
 * 导出客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function exportComplaintRecordOfferExcel(data) {
  return request({
    url: 'api/exportComplaintRecordOfferExcel',
    method: 'post',
    params: data
  })
}
/**
 * 删除客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteComplaintRecord(data) {
  return request({
    url: 'api/deleteComplaintRecord',
    method: 'post',
    params: data
  })
}
/**
 * 修改或添加客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditComplaintRecord(data) {
  return request({
    url: 'api/addOrEditComplaintRecord',
    method: 'post',
    params: data
  })
}
/**
 * 获取责任部门排行
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintDeptRank(data) {
  return request({
    url: 'api/getComplaintDeptRank',
    method: 'post',
    params: data
  })
}
/**
 * 获取客诉未处理个数
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintNum(data) {
  return request({
    url: 'api/getComplaintNum',
    method: 'post',
    params: data
  })
}
/**
 * 获取客诉类型
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintType(data) {
  return request({
    url: 'api/getComplaintType',
    method: 'post',
    params: data
  })
}
/**
 * 获取最近10条客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintRecord(data) {
  return request({
    url: 'api/getComplaintRecord',
    method: 'post',
    params: data
  })
}
/**
 * 获取最近10条客诉记录
 * @param data
 * @returns {AxiosPromise}
 */
export function getComplaintReason(data) {
  return request({
    url: 'api/getComplaintReason',
    method: 'post',
    params: data
  })
}
/**
 * 获取活动签到列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getActiveCheckList(data) {
  return request({
    url: 'api/getActiveCheckList',
    method: 'post',
    params: data
  })
}
/**
 * 添加或修改活动签到
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditActiveCheck(data) {
  return request({
    url: 'api/addOrEditActiveCheck',
    method: 'post',
    params: data
  })
}
/**
 * 获取活动签到选项列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getInfoOption(data) {
  return request({
    url: 'api/getInfoOption',
    method: 'post',
    params: data
  })
}
/**
 * 删除活动签到
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteActiveCheck(data) {
  return request({
    url: 'api/deleteActiveCheck',
    method: 'post',
    params: data
  })
}
/**
 * 导出活动签到表格
 * @param data
 * @returns {AxiosPromise}
 */
export function exportActiveCheckOfferExcel(data) {
  return request({
    url: 'api/exportActiveCheckOfferExcel',
    method: 'post',
    params: data
  })
}
/**
 * 获取签到选项
 * @param data
 * @returns {AxiosPromise}
 */
export function getActiveCheckUserInfo(data) {
  return request({
    url: 'api/getActiveCheckUserInfo',
    method: 'post',
    params: data
  })
}
/**
 * 企划物料列表
 * @returns {AxiosPromise}
 */
export function selectMaterialsList() {
  return request({
    url: 'api/selectMaterialsList',
    method: 'post'
  })
}
/**
 * 添加或者修改物料申领（内部）
 * @param data
 * @returns {AxiosPromise}
 */
export function addOrEditMaterialClaim(data) {
  return request({
    url: 'api/addOrEditMaterialClaim',
    method: 'post',
    params: data
  })
}
/**
 * 根据id查询物料申领（内部）
 * @param data
 * @returns {AxiosPromise}
 */
export function selectMaterialsClaim(data) {
  return request({
    url: 'api/selectMaterialsClaim',
    method: 'post',
    params: data
  })
}
/**
 * 根据id删除物料申领（内部）
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteMaterialClaim(data) {
  return request({
    url: 'api/deleteMaterialClaim',
    method: 'post',
    params: data
  })
}
/**
 * 打印物料申领单（内部）
 * @param data
 * @returns {AxiosPromise}
 */
export function printMaterialsClaim(data) {
  return request({
    url: 'api/printMaterialsClaim',
    method: 'post',
    params: data
  })
}
/**
 * 物料申领单处理（内部）
 * @param data
 * @returns {AxiosPromise}
 */
export function treatMaterialClaim(data) {
  return request({
    url: 'api/treatMaterialClaim',
    method: 'post',
    params: data
  })
}
/**
 * 创建或者修改流程模板
 * @param data
 * @returns {AxiosPromise}
 */
export function createOrEditTemplate(data) {
  return request({
    url: 'api/createOrEditTemplate',
    method: 'post',
    params: data
  })
}
/**
 * 查询流程模板列表
 * @param data
 * @returns {AxiosPromise}
 */
export function selectTemplateData(data) {
  return request({
    url: 'api/selectTemplateData',
    method: 'post',
    params: data
  })
}
/**
 * 根据ID查询流程模板
 * @param data
 * @returns {AxiosPromise}
 */
export function selectByIdFlowTemplate(data) {
  return request({
    url: 'api/selectByIdFlowTemplate',
    method: 'post',
    params: data
  })
}
/**
 * 根据ID删除流程模板
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteByIdFlowTemplate(data) {
  return request({
    url: 'api/deleteByIdFlowTemplate',
    method: 'post',
    params: data
  })
}
/**
 * 创建项目
 * @param data
 * @returns {AxiosPromise}
 */
export function createOrEditProject(data) {
  return request({
    url: 'api/createOrEditProject',
    method: 'post',
    params: data
  })
}
/**
 * 查找我创建的项目
 * @param data
 * @returns {AxiosPromise}
 */
export function getMyProjectData(data) {
  return request({
    url: 'api/getMyProjectData',
    method: 'post',
    params: data
  })
}
/**
 * 查找我创建的项目
 * @param data
 * @returns {AxiosPromise}
 */
export function getMyJoinProjectData(data) {
  return request({
    url: 'api/getMyJoinProjectData',
    method: 'post',
    params: data
  })
}
/**
 * 点击完成任务
 * @param data
 * @returns {AxiosPromise}
 */
export function finishTask(data) {
  return request({
    url: 'api/finishTask',
    method: 'post',
    params: data
  })
}

/**
 * 根据id查询项目详情
 * @param data
 * @returns {AxiosPromise}
 */
export function selectByIdProject(data) {
  return request({
    url: 'api/selectByIdProject',
    method: 'post',
    params: data
  })
}
/**
 * 根据id删除项目
 * @param data
 * @returns {AxiosPromise}
 */
export function deleteByIdProject(data) {
  return request({
    url: 'api/deleteByIdProject',
    method: 'post',
    params: data
  })
}
/**
 * 项目成员编辑
 * @param data
 * @returns {AxiosPromise}
 */
export function projectTeamEdit(data) {
  return request({
    url: 'api/projectTeamEdit',
    method: 'post',
    params: data
  })
}

export function editProjectSetInfo(data) {
  return request({
    url: 'api/editProjectSetInfo',
    method: 'post',
    params: data
  })
}

export function getProjectTaskListByPid(data) {
  return request({
    url: 'api/getProjectTaskListByPid',
    method: 'post',
    params: data
  })
}

export function editProjectStage(data) {
  return request({
    url: 'api/editProjectStage',
    method: 'post',
    params: data
  })
}

export function exportProjectTaskExcel(data) {
  return request({
    url: 'api/exportProjectTaskExcel',
    method: 'post',
    params: data
  })
}

export function editProjectTaskStage(data) {
  return request({
    url: 'api/editProjectTaskStage',
    method: 'post',
    params: data
  })
}

export function editProjectTaskInfo(data) {
  return request({
    url: 'api/editProjectTaskInfo',
    method: 'post',
    params: data
  })
}

export function addOrDelProjectTaskTag(data) {
  return request({
    url: 'api/addOrDelProjectTaskTag',
    method: 'post',
    params: data
  })
}

export function addProjectTask(data) {
  return request({
    url: 'api/addProjectTask',
    method: 'post',
    params: data
  })
}

export function delProjectTask(data) {
  return request({
    url: 'api/delProjectTask',
    method: 'post',
    params: data
  })
}

export function getProjectDynamicList(data) {
  return request({
    url: 'api/getProjectDynamicList',
    method: 'post',
    params: data
  })
}

export function addProjectDynamic(data) {
  return request({
    url: 'api/addProjectDynamic',
    method: 'post',
    params: data
  })
}

export function getProjectFileList(data) {
  return request({
    url: 'api/getProjectFileList',
    method: 'post',
    params: data
  })
}

export function addProjectFile(data) {
  return request({
    url: 'api/addProjectFile',
    method: 'post',
    params: data
  })
}

export function editProjectFile(data) {
  return request({
    url: 'api/editProjectFile',
    method: 'post',
    params: data
  })
}

export function getTodayMerchantsData(data) {
  return request({
    url: 'api/getTodayMerchantsData',
    method: 'post',
    params: data
  })
}

export function editProjectTaskPercent(data) {
  return request({
    url: 'api/editProjectTaskPercent',
    method: 'post',
    params: data
  })
}

export function getMerchantsDataBriefing(data) {
  return request({
    url: 'api/getMerchantsDataBriefing',
    method: 'post',
    params: data
  })
}

export function getMerchantsClientList(data) {
  return request({
    url: 'api/getMerchantsClientList',
    method: 'post',
    params: data
  })
}

export function getMerchantsClientDataAnalysis(data) {
  return request({
    url: 'api/getMerchantsClientDataAnalysis',
    method: 'post',
    params: data
  })
}

export function getMerchantsClientSourceAnalysis(data) {
  return request({
    url: 'api/getMerchantsClientSourceAnalysis',
    method: 'post',
    params: data
  })
}

export function getMerchantsDynamicList(data) {
  return request({
    url: 'api/getMerchantsDynamicList',
    method: 'post',
    params: data
  })
}

export function getMerchantsTeamList(data) {
  return request({
    url: 'api/getMerchantsTeamList',
    method: 'post',
    params: data
  })
}

export function getMerchantsTeamDetail(data) {
  return request({
    url: 'api/getMerchantsTeamDetail',
    method: 'post',
    params: data
  })
}

export function editMerchantsTeamUserMark(data) {
  return request({
    url: 'api/editMerchantsTeamUserMark',
    method: 'post',
    params: data
  })
}

export function editMerchantsTeamClientTran(data) {
  return request({
    url: 'api/editMerchantsTeamClientTran',
    method: 'post',
    params: data
  })
}

export function getLifeBannerList(data) {
  return request({
    url: 'api/getLifeBannerList',
    method: 'post',
    params: data
  })
}

export function getLifeDictionaryList(data) {
  return request({
    url: 'api/getLifeDictionaryList',
    method: 'post',
    params: data
  })
}

export function editLifeDictionaryList(data) {
  return request({
    url: 'api/editLifeDictionaryList',
    method: 'post',
    params: data
  })
}

export function delLifeDictionary(data) {
  return request({
    url: 'api/delLifeDictionary',
    method: 'post',
    params: data
  })
}

export function editLifeBannerList(data) {
  return request({
    url: 'api/editLifeBannerList',
    method: 'post',
    params: data
  })
}

export function delLifeBannerList(data) {
  return request({
    url: 'api/delLifeBannerList',
    method: 'post',
    params: data
  })
}
export function editMarketResearch(data) {
  return request({
    url: 'api/editMarketResearch',
    method: 'post',
    params: data
  })
}
export function selectMarketResearchList(data) {
  return request({
    url: 'api/selectMarketResearchList',
    method: 'post',
    params: data
  })
}
export function delMarketResearch(data) {
  return request({
    url: 'api/delMarketResearch',
    method: 'post',
    params: data
  })
}
export function selectOneByIdMarketResearch(data) {
  return request({
    url: 'api/selectOneByIdMarketResearch',
    method: 'post',
    params: data
  })
}
export function addOrEditYxjClientRefund(data) {
  return request({
    url: 'api/addOrEditYxjClientRefund',
    method: 'post',
    params: data
  })
}
/**
 * 添加首造建店项目
 * @param data
 * @returns {AxiosPromise}
 */
export function szCreateOrEditShop(data) {
  return request({
    url: 'api/szCreateOrEditShop',
    method: 'post',
    params: data
  })
}
/**
 * 获取首造建店项目列表
 * @param data
 * @returns {AxiosPromise}
 */
export function getBuildShopData(data) {
  return request({
    url: 'api/getBuildShopData',
    method: 'post',
    params: data
  })
}
/**
 * 获取首造建店详情
 * @param data
 * @returns {AxiosPromise}
 */
export function selectSzBuildShopDetail(data) {
  return request({
    url: 'api/selectSzBuildShopDetail',
    method: 'post',
    params: data
  })
}
/**
 * 添加首造建店动态
 * @param data
 * @returns {AxiosPromise}
 */
export function addSzBuildShopDynamic(data) {
  return request({
    url: 'api/addSzBuildShopDynamic',
    method: 'post',
    params: data
  })
}
/**
 * 搜索首造建店动态
 * @param data
 * @returns {AxiosPromise}
 */
export function selectSzBuildShopDynamic(data) {
  return request({
    url: 'api/selectSzBuildShopDynamic',
    method: 'post',
    params: data
  })
}
/**
 * 经销商获取首造建店列表
 * @param data
 * @returns {AxiosPromise}
 */
export function delGetBuildShopData(data) {
  return request({
    url: 'api/delGetBuildShopData',
    method: 'post',
    params: data
  })
}
/**
 * 经销商确认动态
 * @param data
 * @returns {AxiosPromise}
 */
export function confirmDynamic(data) {
  return request({
    url: 'api/confirmDynamic',
    method: 'post',
    params: data
  })
}
/**
 * 首造建店添加订单
 * @param data
 * @returns {AxiosPromise}
 */
export function addSzbuildshopOrder(data) {
  return request({
    url: 'api/addSzbuildshopOrder',
    method: 'post',
    params: data
  })
}
/**
 * 首造建店获取订单列表
 * @param data
 * @returns {AxiosPromise}
 */
export function selectSidOrderDataList(data) {
  return request({
    url: 'api/selectSidOrderDataList',
    method: 'post',
    params: data
  })
}

